/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Error_Datatemporarilyunavailable2Inputs */

const en_analytics_error_datatemporarilyunavailable2 = /** @type {(inputs: Analytics_Error_Datatemporarilyunavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data temporarily unavailable`)
};

/**
* | output |
* | --- |
* | "Data temporarily unavailable" |
*
* @param {Analytics_Error_Datatemporarilyunavailable2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const analytics_error_datatemporarilyunavailable2 = /** @type {((inputs?: Analytics_Error_Datatemporarilyunavailable2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Error_Datatemporarilyunavailable2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_analytics_error_datatemporarilyunavailable2(inputs)
});
export { analytics_error_datatemporarilyunavailable2 as "analytics_error_dataTemporarilyUnavailable" }